


























































































import { Component, Vue } from 'vue-property-decorator'
import { ApiService } from '../../api/api.service'
import { UserModule } from '../../store/modules/user'
import { getBoUrl } from '../../api/http-constants'
import { getAppUrl } from '@/api/http-constants'
import Alert from '@/components/Alert.vue'
import get from 'lodash/get'

@Component({
    components: {
        Alert,
    },
})
export default class SelectOpe extends Vue {
    loading: boolean = true
    userID: number = null
    allOpe: any[] = []
    abandonedOpeName: string = null

    async attachToOpe(ope) {
        const apiService = new ApiService()

        try {
            const resp = await apiService.patchAttachUserToOperation(
                this.userID,
                ope.id
            )

            // On redirige vers l'ope
            window.location.href = ope.opeUrl
        } catch (error) {
            const $alert = this.$refs.alert as Alert
            $alert.handleAlert(
                'danger',
                `Erreur lors de votre inscription à l'opération ${ope.name}`
            )
        }
    }

    async created() {
        console.log('🔵 SelectOpe.created()')
        const apiService = new ApiService()

        try {
            console.log('🔵 Initialisation de SelectOpe.vue')
            await UserModule.Init()
            console.log('✅ UserModule initialisé')
            const userID = UserModule.userInfos.id
            this.userID = userID
            console.log('🔵 userID:', userID)

            if (!userID) {
                throw new Error('UserID est null ou undefined')
            }

            const boUrl = getBoUrl()

            const allUserOpeResp = await apiService.getUserOperations(userID)
            console.log("test ici", allUserOpeResp)
            const allUserOpe = allUserOpeResp.data

            const allOpeResp = await apiService.getAllOpe()
            const allOpe = allOpeResp.data

            let finalOpe = allOpe.map(ope => {
                const userOpe = allUserOpe.find(userOpe => {
                    return userOpe.operation.id === ope.id
                })

                const isMember = userOpe ? true : false
                const abandonedAt = userOpe ? userOpe.abandonedAt : null

                const appUrl = getAppUrl()
                const opeUrl = `//${ope.slug}.${appUrl}/`
                const city = get(ope, 'land.address.city', null)

                return {
                    id: ope.id,
                    name: ope.name,
                    imagePath: `${boUrl}${ope.imagePath}?t=${new Date().valueOf()}`,
                    opeUrl,
                    discoverUrl: ope.url,
                    isMember,
                    city,
                    abandonedAt,
                }
            })

            // Si il n'y a qu'une seule opé, on skip l'écran de sélection
            if (finalOpe.length === 1) {
                const ope = finalOpe[0]
                if (ope.abandonedAt) {
                    this.abandonedOpeName = ope.name
                } else if (ope.isMember) {
                    window.location.href = ope.opeUrl
                } else {
                    await this.attachToOpe(ope)
                }
                return
            }

            this.allOpe = finalOpe
            console.log('🔵 allOpe:', this.allOpe)
            this.loading = false

        } catch (error) {
            console.error('❌ ERREUR GLOBALE:', error)
            if (error.response) {
                console.error('Status:', error.response.status)
                console.error('Data:', error.response.data)
                console.error('Headers:', error.response.headers)
            }

            const $alert = this.$refs.alert as Alert
            if ($alert) {
                $alert.handleAlert(
                    'danger',
                    'Erreur lors du chargement des opérations'
                )
            }
        }
    }
}
